const { Secure } = require("mali-secure")
import axios from 'axios'

// const developUrl = 'https://dev-chinese.aaqq.in:8080';//开发环境
// const productUrl = 'https://api-class.bestmali.cn';//生产环境
const productUrl = ''
var environment = 'product';

axios.defaults.baseURL = productUrl;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.post['Accept'] = 'application/json';

function changeBaseUrl(){
    if(environment == 'develop'){
        axios.defaults.baseURL = productUrl
        environment = 'product'
    }else if(environment == 'product'){
        axios.defaults.baseURL = developUrl
        environment = 'develop'
    }
    return environment
}

function formatUrl(that,url,text,per){
    // cid   :商户 id
    // openid:三方用户 id
    // secret:秘钥
    let s = new Secure("cid", "123456", "192006250b4c09247ec02edce69f6a2d")

    // 获取微信支付公共签名后的地址
    let uri = s.getSign('https://api-class.bestmali.cn'+apiMap[url])
    return uri
}
function get(that,params){
    axios.get(formatUrl(that,params.url))
    .then((res)=>{
        let result = res.data
        if(result.code == 0){
            params.success(result.data)
        }else if(result.code == -1911){
            checkFalse(that)
        }else{
            if(params.error){
                params.error()
            }
        }
    })
    .catch((error)=>{
        console.log('catch',error)
    })
}


function post(that,params){
    var token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
    axios({
        method:"post",
        url:formatUrl(that,params.url),
        data:params.data,
        transformRequest: [function (data) {
            let ret = ''
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret.substr(0, ret.length - 1)
        }],
        headers:{
            "Authorization":'Bearer ' + token
        }     
    })
    .then((res)=>{ 
        // console.log(res)
        let result = res.data ? res.data : {}
        let s = new Secure("cid", "123456", "192006250b4c09247ec02edce69f6a2d")
        result = s.decrypt(result)
        // console.log(result)
        if(result.code == 0){
            params.success(s.checkBase64(result.data))
        }else if(result.code == -999){
            checkFalse(that)
        }else{
            let error = result.msg
            that.$Message['error']({
                background: true,
                content: error
            })
            // if(params.error){
            //     params.error(result)
            // }
        }
    })
    .catch((res)=>{
        // console.log(res)
    })
}

function checkFalse(that){
    // that.$store.commit('clearUser')
    // that.toast('请先登录')
    localStorage.clear()
    setTimeout(()=>{
        that.$store.commit('setCheck',false)
    },1000)
}

function postImage(that,file,reData,params){
    var ossData = new FormData()
    var date = new Date()
    var s = date.getTime()
    var fileName = s + file.name.toLowerCase()
    var filepathName = reData.dir + "/" + fileName
    ossData.append("name", fileName)
    ossData.append("key",filepathName)
    ossData.append("policy", reData.policy)
    ossData.append("OSSAccessKeyId", reData.accessid)
    ossData.append("success_action_status", 201)
    ossData.append("signature", reData.signature)
    ossData.append("file", file)
    axios.post(reData.host,ossData,{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        transformRequest:function(data){
            return data
        }
    }).then(res => {
        params.success(filepathName)
    })
}

const apiMap = {
    //auth
    userLogin:'/sso/auth/userLogin',
    wxLogin:'/sso/auth/wxLogin',
    getMiniToken:'/sso/auth/getMiniToken',//微信小程序登录获取token
    getOssToken: "/sso/auth/getOssToken",
    getLegalize:'/sso/legalize/get',//获取用户认证信息接口
    applyLegalize:'/sso/legalize/apply',//申请认证
    //课堂
    createClass:'/live/class/createClass',//创建课堂
    getClassList:'/live/class/getClassListForOpenid',//获取直播列表
    getReplay:'/live/replay/getReplay',//获取直播回放数据
    getReplayVideo:'/live/replay/getReplayVideo',//获取直播回放数据
    getClass:'/live/class/getClass',
    getUserInfo:'/sso/auth/getUserInfo',//获取用户信息
}

// 获取一次性字符串
function generateNonceString(length) {
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
	var maxPos = chars.length
	var noceStr = ""
	for (var i = 0; i < (length || 32); i++) {
		noceStr += chars.charAt(Math.floor(Math.random() * maxPos))
	}
	return noceStr
}

export default{post,get,changeBaseUrl,formatUrl,postImage}